import type { TTimestamp } from '@/types';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

import { useSettingsStore } from '@/store/useSettingsStore';

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const useRelativeTime = () => {
  const language = useSettingsStore((s) => s.settings.language);

  dayjs.locale(language);

  const normalizeTimestamp = (value: TTimestamp): number => {
    const time = value instanceof Date ? value.getTime() : Number(value);
    return time.toString().length === 10 ? time * 1000 : time;
  };

  return {
    fromNow: (value: TTimestamp) =>
      value ? dayjs.utc(normalizeTimestamp(value)).fromNow() : '',
  };
};
